// Copy for the static public pages. Kept as DATA (not five near-identical .vue
// files) so the marketing copy is editable in one place and every page is
// guaranteed the same layout.
//
// HONESTY NOTE: billing is deliberately deferred (the Stripe rails exist in
// saas-core; there is no checkout, no plans, no paid tier). The Pricing page
// therefore says i-Recall is free — it must NOT imply a paid tier that cannot be
// bought. Rewrite this the day billing actually ships, not before.
//
// These are placeholders for a real writer. They are honest and complete enough
// to publish, but they are not marketing copy.

export const PUBLIC_PAGES = {
  "how-it-works": {
    title: "How it works",
    lead: "i-Recall asks the question out loud. You answer out loud. It coaches you through the gap.",
    sections: [
      { h: "1. Pick a topic", p: "Choose any deck from the library — no account needed to begin. Each deck is a set of multiple-choice questions on one subject." },
      { h: "2. Answer out loud", p: "The question and its four options are read to you. Speak your answer — say the letter (\"B\"), or just say the option itself. You can also click if you'd rather not speak." },
      { h: "3. Get coached, not just marked", p: "A right answer moves you on. A wrong one gets a tailored hint and a second attempt. After two attempts the answer is revealed and explained — so you never leave a question without knowing why." },
      { h: "Why out loud?", p: "Speaking an answer is active recall: it forces retrieval rather than recognition, which is what actually moves knowledge into long-term memory. Reading a list of answers feels productive and mostly isn't." }
    ]
  },

  pricing: {
    title: "Pricing",
    lead: "i-Recall is free to use while we're in beta.",
    sections: [
      { h: "Free, for now", p: "Every topic in the public library is free to play, with or without an account. Creating a free account adds your own library, your history and your progress." },
      { h: "What we'll charge for later", p: "Paid plans are not available yet. When they arrive they'll cover team workspaces, private content libraries and bulk authoring — the things organisations need. Individual learning on the public library is intended to stay free." },
      { h: "No card, no catch", p: "There's nothing to buy on this site today. If that changes, it will be announced here first — not slipped into your account." }
    ]
  },

  about: {
    title: "About i-Recall",
    lead: "A voice-driven recall tutor, built on the idea that saying it beats skimming it.",
    sections: [
      { h: "What it is", p: "i-Recall reads a question and its options aloud, listens to your spoken answer, grades it, and coaches you through what you missed. It works in a browser, on a phone or a laptop, hands-free." },
      { h: "Who it's for", p: "Anyone who has to hold a body of knowledge in their head and be right about it under pressure — clinicians, drivers, students, and the organisations that train them." },
      { h: "Who makes it", p: "i-Recall is built by Digital Streams." }
    ]
  },

  contact: {
    title: "Contact",
    lead: "We'd like to hear from you.",
    sections: [
      { h: "Get in touch", p: "For anything at all — questions, problems, content partnerships, or a bug you'd like fixed — email us and a human will reply." },
      { h: "Email", p: "hello@i-recall.au" }
    ]
  },

  privacy: {
    title: "Privacy Policy",
    lead: "Placeholder — this page needs review by a person qualified to write it.",
    sections: [
      { h: "This is not yet a legal document", p: "This page is a placeholder. It should be replaced with a reviewed privacy policy before i-Recall takes real user traffic or handles personal data at any scale." },
      { h: "What the product does today, plainly", p: "If you create an account we store your email address and the answers you give, so we can show you your history and progress. Your spoken answer is sent to a speech-to-text service to be transcribed, and is not retained as audio. We do not sell anything to anyone." },
      { h: "Questions", p: "Email hello@i-recall.au and ask. We'll answer straight." }
    ]
  },

  terms: {
    title: "Terms of Service",
    lead: "Placeholder — this page needs review by a person qualified to write it.",
    sections: [
      { h: "This is not yet a legal document", p: "This page is a placeholder and should be replaced with reviewed terms before launch." },
      { h: "In the meantime", p: "i-Recall is provided as-is, free, during beta. Content in the public library is for learning and revision; it is not professional, medical or legal advice, and it should not be relied on as such." }
    ]
  }
};
